import { ref, watch, computed, getCurrentInstance } from '@vue/composition-api'
import store from '@/store'
import moment from 'moment'
import { formatDateMX, kFormatter, cFormatter } from '@core/utils/filter'
import { t } from '@core/libs/i18n/utils'
// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useCfdiList() {
  // Use toast
  const toast = useToast()

  const refCfdiListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'folio', 
      label: 'Folio',
      //sortable: true
    },
    { 
      key: 'customer', 
      label: 'Customer Name',
      //sortable: true 
    },
    { 
      key: 'taxid', 
      label: 'Tax ID',
      //sortable: true 
    },
    {
      key: 'edate', //ILL: 190222 se homologa el key como está en cfdilist columna fecha del comprobante
      label: 'Invoice Date',
      //sortable: true,
    },
    {
      key: 'status',
      label: 'Status',
      //sortable: true,
    },
    { 
      key: 'total', //ILL: 190222 se homologa el key como está en cfdilist columna total del comprobante
      label: 'Total',
      //sortable: true
    },
    { 
      key: 'actions',
      label: 'Actions',
    },
  ]
  const perPage = ref(10)
  const totalCfdis = ref(0)
  const listCfdis = ref([])
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const listScope = ref(moment().format('MMYYYY'))
  const isScopeEnabled = ref(true)
  const isFoliosScope = ref(false)
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const roleFilter = ref(null)
  const planFilter = ref(null)
  const statusFilter = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refCfdiListTable.value ? refCfdiListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalCfdis.value,
    }
  })

  const refetchData = () => {
    refCfdiListTable.value.refresh()
  }

  watch([searchQuery, listScope], (v) => {
    if(searchQuery.value !== '' && searchQuery.value.length >= 4) {
      isScopeEnabled.value = false
      refetchData()  
    } else if (searchQuery.value === '') {
      isScopeEnabled.value = true
      refetchData()  
    }
  })

  watch([currentPage, perPage] , () => {
    refetchData()  
  })

  const fetchCfdis = (ctx, callback) => {
    store
      .dispatch('fg-cfdi/listCfdi', {
        q: searchQuery.value,
        scope: listScope.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
      })
      .then(response => {
        const { cfdis, total, meta } = response.data

        callback(cfdis)
        /** For analyzing the resultant cfdi's */
        listCfdis.value = cfdis
        totalCfdis.value = total

        if(meta && meta.isFoliosScope) { 
          isFoliosScope.value = true 
        }
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching cfdi list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  const resolveCfdiTypeVariant = type => {
    if (type === 'pm') return 'primary'
    if (type === 'pf') return 'secondary'
    return 'primary'
  }

  return {
    fetchCfdis,
    tableColumns,
    listScope,
    isScopeEnabled,
    isFoliosScope,
    perPage,
    currentPage,
    totalCfdis,
    listCfdis,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refCfdiListTable,

    resolveCfdiTypeVariant,

    refetchData,

    // Extra Filters
    roleFilter,
    planFilter,
    statusFilter,
  }
}
